export default "__VITE_ASSET__BuRC_12t__";